/* eslint-disable */
<template>
  <div>
    <div class="login">
      <div class="intro">
        <div class="rw pt-4">
          <illustration />
        </div>
        <div class="rw" style="margin-top: -70px">
          <h3>Work On The Go</h3>
          <p class="slogan">
            Collaborate &nbsp; . &nbsp; Share &nbsp; . &nbsp; Save Files &nbsp;
            . &nbsp; Organise Your Work Flow
          </p>
        </div>
      </div>
      <div class="form">
        <div>
          <div class="logo">
            <a href="http://fexspace.com"
              ><img
                src="../../public/logo-small.png"
                width="120px"
                height="auto"
            /></a>
          </div>
          <h3>Hi, Welcome Back</h3>
          <p class="tagline">
            You can sign in with your social account or using email.
          </p>
          <div class="mt-4">
            <p class="d-flex justify-content-between">
              <span class="gmail-login" @click="login_pop('gmail')">
                <span class="d-flex justify-content-center align-items-center">
                  <img src="@/assets/google.png" />
                  <span class="google-text">Google</span>
                </span>
                <span>
                  <img
                    src="@/assets/spinner-200px.gif"
                    width="45px"
                    v-if="google_loader"
                  />
                </span>
              </span>
              &nbsp; &nbsp;
              <span class="linked-login" @click="login_pop('linkedin')">
                <span class="d-flex justify-content-center align-items-center">
                  <img src="@/assets/linkedin.svg" /> &nbsp;&nbsp;&nbsp;<span
                    class="linkedin-text"
                    >LinkedIn</span
                  >
                </span>
                <span>
                  <img
                    src="@/assets/spinner-200px.gif"
                    width="45px"
                    class="loader"
                    v-if="linked_loader"
                  />
                </span>
              </span>
            </p>
          </div>
          <div class="hr d-flex justify-content-between align-items-center">
            <hr />
            <span>Or sign in with email</span>
            <hr />
          </div>
          <form @keypress="send" @submit.prevent>
            <div class="error-login animated slideInUp" v-if="error.message">
              Login details is incorrect
              <i class="fa fa-times" @click="close"></i>
            </div>
            <div class="mb-4">
              <!--<label>Email Address</label>-->
              <input
                type="text"
                placeholder="Enter email address"
                name="email"
                v-model="email"
              />
              <span class="error" v-if="error.email">*Required</span>
            </div>
            <div class="mb-1">
              <!--<label>Password</label>-->
              <input
                :type="[!reveal ? 'password' : 'text']"
                name="password"
                placeholder="Enter your password"
                v-model="password"
              />
              <span class="reveal" @click="reveal_password">
                <img src="@/assets/No Preview.svg" v-if="!reveal" />
                <img src="@/assets/eye.svg" v-if="reveal" />
              </span>
              <span class="error" v-if="error.password">*Required</span>
            </div>
            <div class="keepme" style="margin-top: 0">
              <label>
                <input type="checkbox" v-model="keepme" /> Keep Me Logged In
              </label>
              <span>
                <router-link to="/forgot-password"
                  >Forgot Password?</router-link
                >
              </span>
            </div>
            <div class="mt-5">
              <button type="button" @click="submit">Sign In</button>
            </div>
            <div class="dont">
              <p>
                Don't Have An Account?
                <strong
                  ><router-link to="/create-account"
                    >Sign Up</router-link
                  ></strong
                >
              </p>
            </div>
            <p class="copy-right">
              &copy; {{ year }} Fexspace. All Rights Reserved.
            </p>
          </form>
          <!--<div class="mfes-trustmark" data-type="102" data-width="80" data-height="33"></div>-->
        </div>
      </div>
    </div>
    <loading ref="loading"></loading>
  </div>
</template>
<style scoped>
img {
  max-width: 100%;
}
.copy-right {
  text-align: left;
  margin: 0;
  font-family: "DM Sans";
  font-size: 16px;
  color: #677888;
  margin-bottom: -20px;
}
.hr {
  margin: 1em 0;
}
.hr hr {
  flex-grow: 1;
}
.hr hr {
  flex-grow: 1;
}
.hr span {
  color: #4b5458;
  font-family: "DM Sans";
  font-size: 16px;
}
.hr hr:nth-child(1) {
  margin-right: 10px;
  border-top: 1px solid #a7b9cb !important;
}
.hr hr:nth-child(3) {
  margin-left: 10px;
  border-top: 1px solid #a7b9cb !important;
}
.linkedin-text,
.google-text {
  font-family: "DM Sans" !important;
  color: #111 !important;
  font-size: 16px !important;
  font-weight: bold !important;
}
.gmail-login {
  border: 1px solid #ababab;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  width: 50%;
  height: 55px;
}
.gmail-login span {
  font-weight: normal;
  font-size: 15px;
  margin-left: 0.8em;
}
.linked-login {
  border: 1px solid #ababab;
  cursor: pointer;
  display: flex;
  justify-content: center;
  border-radius: 5px;
  align-items: left;
  height: 55px;
  width: 50%;
}
.linked-login span {
  max-width: 105px;
}
.linked-login img.linkedin-img {
  margin-top: 16px;
}
.linked-login .loader {
  margin-top: 0.3em;
}
.login .form form {
  margin-top: 0;
}
</style>
<script>
import AuthenticationService from "@/services/AuthenticationService";
import loading from "@/components/Loading";
import cookies from "@/services/cookies";
import { mapMutations } from "vuex";
import Illustration from '@/components/Icons/Illustration'

export default {
  components: {
    loading,
    Illustration
  },
  data() {
    return {
      reveal: false,
      email: "",
      password: "",
      keepme: false,
      error: {
        email: false,
        password: false,
        message: false,
      },
      post: true,
      linked_loader: false,
      google_loader: false,
      year: "",
    };
  },
  methods: {
    ...mapMutations([
      "SET_DIRECTORY_CHILDREN",
      "SET_IS_SECURITY_QUESTION",
      "SET_HAS_ON_BOARDED",
    ]),
    login_pop(type) {
      if (type === "gmail") {
        this.google_loader = true;
      } else {
        this.linked_loader = true;
      }

      let data = {
        type,
      };

      AuthenticationService.auth(data)
        .then((res) => {
          window.location = res.data.link;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    reveal_password() {
      this.reveal = !this.reveal;
    },
    close() {
      this.error.message = false;
    },
    send(evt) {
      if (evt.keyCode === 13) {
        this.post = true;

        if (this.email === "") {
          this.post = false;
          this.error.email = true;
        } else {
          this.error.email = false;
        }

        if (this.password === "") {
          this.post = false;
          this.error.password = true;
        } else {
          this.error.password = false;
        }

        if (this.post) {
          let that = this;
          this.$refs.loading.load();

          sessionStorage.setItem("keepme", this.keepme);

          let data = {
            email: this.email,
            password: this.password,
            keepme: this.keepme
          };

          AuthenticationService.login(data)
            .then((res) => {
              if (res.data.data === true) {
                // If your plan type is 1. You are a free user
                localStorage.setItem("hasOnboarded", res.data.hasOnboarded);
                sessionStorage.setItem("dir_id", res.data.directory_id);

                if (res.data.type === 1) {
                  localStorage.setItem("id", res.data.id);
                  // that.$refs.loading.close()
                  sessionStorage.setItem("user", res.data.email);
                  sessionStorage.setItem("userId", res.data.user_id);
                  sessionStorage.setItem("isAdmin", res.data.isAdmin);
                  sessionStorage.setItem("isLoggedIn", true);
                  // sessionStorage.setItem('isFirstTime', res.data.isFirstTime)
                  sessionStorage.setItem("status", true);
                  // that.SET_IS_SECURITY_QUESTION(res.data.ask_question)
                  localStorage.setItem(
                    "is_security_question",
                    res.data.ask_question
                  );
                  if (process.env.VUE_APP_NODE_TYPE === "development") {
                    that.$router.push("/");
                  }

                  if (process.env.VUE_APP_NODE_TYPE === "devment") {
                    window.location = "https://app.fexdrive.com";
                  }

                  if (process.env.VUE_APP_NODE_TYPE === "production") {
                    window.location = "https://app.fexspace.com";
                  }
                  return;
                }

                if (res.data.stage === 2) {
                  // cookies.setCookie('regtoken', res.data.token, 6 * 60 * 60 * 1000)
                  cookies.removeCookie(
                    "email",
                    res.data.email,
                    6 * 60 * 60 * 1000
                  );
                  cookies.removeCookie(
                    "name",
                    res.data.name,
                    6 * 60 * 60 * 1000
                  );
                  cookies.removeCookie(
                    "tran_ref",
                    res.data.tran_ref,
                    6 * 60 * 60 * 1000
                  );
                  that.$router.push("/setup-account");
                }

                if (res.data.stage === 6) {
                  if (process.env.VUE_APP_NODE_TYPE == "development") {
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    // window.location = 'http://192.168.1.2:3000/pricing-free-trial'
                    window.location = "http://192.168.1.2:3000/plan-trial";
                  }

                  if (process.env.VUE_APP_NODE_TYPE == "devment") {
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    // window.location = 'http://fexdrive.com/pricing-free-trial'
                    window.location = "http://fexdrive.com/plan-trial";
                  }

                  if (process.env.VUE_APP_NODE_TYPE == "production") {
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    // window.location = 'http://fexspace.com/pricing-free-trial'
                    window.location = "http://fexspace.com/plan-trial";
                  }
                }

                if (res.data.stage === 7 || res.data.stage == null) {
                  if (process.env.VUE_APP_NODE_TYPE == "development") {
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    // window.location = 'http://192.168.1.2:3000/choose-plan'
                    window.location = "http://192.168.1.2:3000/plan-trial";
                  }

                  if (process.env.VUE_APP_NODE_TYPE == "devment") {
                    cookies.setCookie(
                      "email",
                      res.data.email,
                      6 * 60 * 60 * 1000
                    );
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    cookies.setCookie(
                      "tran_ref",
                      res.data.tran_ref,
                      6 * 60 * 60 * 1000
                    );
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    // window.location = 'http://fexdrive.com/choose-plan'
                    window.location = "http://fexdrive.com/plan-trial";
                  }

                  if (process.env.VUE_APP_NODE_TYPE == "production") {
                    cookies.setCookie(
                      "email",
                      res.data.email,
                      6 * 60 * 60 * 1000
                    );
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    cookies.setCookie(
                      "tran_ref",
                      res.data.tran_ref,
                      6 * 60 * 60 * 1000
                    );
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    // window.location = 'http://fexspace.com/choose-plan'
                    window.location = "http://fexspace.com/plan-trial";
                  }
                }

                if (res.data.stage === 3) {
                  if (this.$route.query.redirect !== undefined) {
                    that.SET_IS_SECURITY_QUESTION(res.data.ask_question);
                    localStorage.setItem(
                      "is_security_question",
                      res.data.ask_question
                    );
                    sessionStorage.setItem("user", res.data.email);
                    sessionStorage.setItem("userId", res.data.user_id);
                    sessionStorage.setItem("isAdmin", res.data.isAdmin);
                    sessionStorage.setItem("isFirstTime", res.data.isFirstTime);
                    sessionStorage.setItem("isLoggedIn", true);
                    sessionStorage.setItem(
                      "redirect",
                      this.$route.query.redirect
                    );
                    that.$router.push("/authenticate");
                  }
                  // cookies.setCookie('token', res.data.token, 6 * 60 * 60 * 1000)
                  if (res.data.ask_question == true) {
                    sessionStorage.setItem("user", res.data.email);
                    sessionStorage.setItem("userId", res.data.user_id);
                    sessionStorage.setItem("isAdmin", res.data.isAdmin);
                    sessionStorage.setItem("isLoggedIn", true);
                    sessionStorage.setItem("isFirstTime", res.data.isFirstTime);
                    that.SET_IS_SECURITY_QUESTION(res.data.ask_question);
                    localStorage.setItem(
                      "is_security_question",
                      res.data.ask_question
                    );
                    that.$router.push("/authenticate");
                  } else {
                    localStorage.setItem("id", res.data.id);
                    // that.$refs.loading.close()
                    sessionStorage.setItem("user", res.data.email);
                    sessionStorage.setItem("userId", res.data.user_id);
                    sessionStorage.setItem("isAdmin", res.data.isAdmin);
                    sessionStorage.setItem("isLoggedIn", true);
                    sessionStorage.setItem("isFirstTime", res.data.isFirstTime);
                    sessionStorage.setItem("status", true);
                    that.SET_IS_SECURITY_QUESTION(res.data.ask_question);
                    localStorage.setItem(
                      "is_security_question",
                      res.data.ask_question
                    );
                    if (process.env.VUE_APP_NODE_TYPE === "development") {
                      that.$router.push("/");
                    }

                    if (process.env.VUE_APP_NODE_TYPE === "devment") {
                      window.location = "https://app.fexdrive.com";
                    }

                    if (process.env.VUE_APP_NODE_TYPE === "production") {
                      window.location = "https://app.fexspace.com";
                    }
                  }
                }

                if (res.data.stage === 5) {
                  let url = "";

                  if (res.data.type === 2) {
                    url = "personal-pro";
                  }

                  if (res.data.type === 3) {
                    url = "business";
                  }

                  if (res.data.type === 4) {
                    url = "business-plus";
                  }

                  cookies.setCookie(
                    "email",
                    res.data.email,
                    6 * 60 * 60 * 1000
                  );
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  cookies.setCookie(
                    "tran_ref",
                    res.data.tran_ref,
                    6 * 60 * 60 * 1000
                  );

                  if (process.env.VUE_APP_NODE_TYPE === "development") {
                    window.location =
                      "http://localhost:3000/complete-purchase/" + url;
                  }

                  if (process.env.VUE_APP_NODE_TYPE === "devment") {
                    window.location =
                      "http://fexdrive.com/complete-purchase/" + url;
                  }

                  if (process.env.VUE_APP_NODE_TYPE === "production") {
                    window.location =
                      "http://fexspace.com/complete-purchase/" + url;
                  }
                }
                // that.$refs.loading.close()
              } else {
                that.$refs.loading.close();
                that.error.message = true;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    submit() {
      this.post = true;

      if (this.email === "") {
        this.post = false;
        this.error.email = true;
      } else {
        this.error.email = false;
      }

      if (this.password === "") {
        this.post = false;
        this.error.password = true;
      } else {
        this.error.password = false;
      }

      if (this.post) {
        let that = this;
        this.$refs.loading.load();

        sessionStorage.setItem("keepme", this.keepme);

        let data = {
          email: this.email,
          password: this.password,
          keepme: this.keepme
        };

        AuthenticationService.login(data)
          .then((res) => {
            if (res.data.data === true) {
              // If your plan type is 1. You are a free user
              localStorage.setItem("hasOnboarded", res.data.hasOnboarded);
              sessionStorage.setItem("dir_id", res.data.directory_id);

              console.log(res.data)

              if (res.data.type === 1) {
                localStorage.setItem("id", res.data.id);
                // that.$refs.loading.close()
                sessionStorage.setItem("user", res.data.email);
                sessionStorage.setItem("userId", res.data.user_id);
                sessionStorage.setItem("isAdmin", res.data.isAdmin);
                sessionStorage.setItem("isLoggedIn", true);
                // sessionStorage.setItem('isFirstTime', res.data.isFirstTime)
                sessionStorage.setItem("status", true);
                sessionStorage.setItem("dir_id", res.data.directory_id);
                // that.SET_IS_SECURITY_QUESTION(res.data.ask_question)
                localStorage.setItem(
                  "is_security_question",
                  res.data.ask_question
                );
                if (process.env.VUE_APP_NODE_TYPE === "development") {
                  that.$router.push("/");
                }

                if (process.env.VUE_APP_NODE_TYPE === "devment") {
                  window.location = "https://app.fexdrive.com";
                }

                if (process.env.VUE_APP_NODE_TYPE === "production") {
                  window.location = "https://app.fexspace.com";
                }
                return;
              }

              if (res.data.stage === 2) {
                // cookies.setCookie('regtoken', res.data.token, 6 * 60 * 60 * 1000)
                cookies.removeCookie(
                  "email",
                  res.data.email,
                  6 * 60 * 60 * 1000
                );
                cookies.removeCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                cookies.removeCookie(
                  "tran_ref",
                  res.data.tran_ref,
                  6 * 60 * 60 * 1000
                );
                that.$router.push("/setup-account");
              }

              if (res.data.stage === 6) {
                if (process.env.VUE_APP_NODE_TYPE == "development") {
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  // window.location = 'http://192.168.1.2:3000/pricing-free-trial'
                  window.location = "http://192.168.1.2:3000/plan-trial";
                }

                if (process.env.VUE_APP_NODE_TYPE == "devment") {
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  // window.location = 'http://fexdrive.com/pricing-free-trial'
                  window.location = "http://fexdrive.com/plan-trial";
                }

                if (process.env.VUE_APP_NODE_TYPE == "production") {
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  // window.location = 'http://fexspace.com/pricing-free-trial'
                  window.location = "http://fexspace.com/plan-trial";
                }
              }

              if (res.data.stage === 7 || res.data.stage == null) {
                if (process.env.VUE_APP_NODE_TYPE == "development") {
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  // window.location = 'http://192.168.1.2:3000/choose-plan'
                  window.location = "http://192.168.1.2:3000/plan-trial";
                }

                if (process.env.VUE_APP_NODE_TYPE == "devment") {
                  cookies.setCookie(
                    "email",
                    res.data.email,
                    6 * 60 * 60 * 1000
                  );
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  cookies.setCookie(
                    "tran_ref",
                    res.data.tran_ref,
                    6 * 60 * 60 * 1000
                  );
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  // window.location = 'http://fexdrive.com/choose-plan'
                  window.location = "http://fexdrive.com/plan-trial";
                }

                if (process.env.VUE_APP_NODE_TYPE == "production") {
                  cookies.setCookie(
                    "email",
                    res.data.email,
                    6 * 60 * 60 * 1000
                  );
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  cookies.setCookie(
                    "tran_ref",
                    res.data.tran_ref,
                    6 * 60 * 60 * 1000
                  );
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  // window.location = 'http://fexspace.com/choose-plan'
                  window.location = "http://fexspace.com/plan-trial";
                }
              }

              if (res.data.stage === 3) {
                if (this.$route.query.redirect !== undefined) {
                  that.SET_IS_SECURITY_QUESTION(res.data.ask_question);
                  localStorage.setItem(
                    "is_security_question",
                    res.data.ask_question
                  );
                  sessionStorage.setItem("user", res.data.email);
                  sessionStorage.setItem("userId", res.data.user_id);
                  sessionStorage.setItem("isAdmin", res.data.isAdmin);
                  sessionStorage.setItem("isFirstTime", res.data.isFirstTime);
                  sessionStorage.setItem("dir_id", res.data.directory_id);
                  sessionStorage.setItem("isLoggedIn", true);
                  sessionStorage.setItem(
                    "redirect",
                    this.$route.query.redirect
                  );
                  that.$router.push("/authenticate");
                }
                // cookies.setCookie('token', res.data.token, 6 * 60 * 60 * 1000)
                if (res.data.ask_question == true) {
                  sessionStorage.setItem("user", res.data.email);
                  sessionStorage.setItem("userId", res.data.user_id);
                  sessionStorage.setItem("isAdmin", res.data.isAdmin);
                  sessionStorage.setItem("isLoggedIn", true);
                  sessionStorage.setItem("isFirstTime", res.data.isFirstTime);
                  sessionStorage.setItem("dir_id", res.data.directory_id);
                  that.SET_IS_SECURITY_QUESTION(res.data.ask_question);
                  localStorage.setItem(
                    "is_security_question",
                    res.data.ask_question
                  );
                  that.$router.push("/authenticate");
                } else {
                  localStorage.setItem("id", res.data.id);
                  // that.$refs.loading.close()
                  sessionStorage.setItem("user", res.data.email);
                  sessionStorage.setItem("userId", res.data.user_id);
                  sessionStorage.setItem("isAdmin", res.data.isAdmin);
                  sessionStorage.setItem("isLoggedIn", true);
                  sessionStorage.setItem("isFirstTime", res.data.isFirstTime);
                  sessionStorage.setItem("dir_id", res.data.directory_id);
                  sessionStorage.setItem("status", true);
                  that.SET_IS_SECURITY_QUESTION(res.data.ask_question);
                  localStorage.setItem(
                    "is_security_question",
                    res.data.ask_question
                  );
                  if (process.env.VUE_APP_NODE_TYPE === "development") {
                    that.$router.push("/");
                  }

                  if (process.env.VUE_APP_NODE_TYPE === "devment") {

                    if (this.$route.query.redirect !== undefined && this.isValidURL(this.$route.query.redirect)) {
                      window.location = this.$route.query.redirect
                    }

                    window.location = "https://app.fexdrive.com";
                  }

                  if (process.env.VUE_APP_NODE_TYPE === "production") {

                    if (this.$route.query.redirect !== undefined && this.isValidURL(this.$route.query.redirect)) {
                      window.location = this.$route.query.redirect
                    }

                    window.location = "https://app.fexspace.com";
                  }
                }
              }

              if (res.data.stage === 5) {
                let url = "";

                if (res.data.type === 2) {
                  url = "personal-pro";
                }

                if (res.data.type === 3) {
                  url = "business";
                }

                if (res.data.type === 4) {
                  url = "business-plus";
                }

                cookies.setCookie("email", res.data.email, 6 * 60 * 60 * 1000);
                cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                cookies.setCookie(
                  "tran_ref",
                  res.data.tran_ref,
                  6 * 60 * 60 * 1000
                );

                if (process.env.VUE_APP_NODE_TYPE === "development") {
                    window.location =
                      "http://localhost:3000/complete-purchase/" + url;
                }

                if (process.env.VUE_APP_NODE_TYPE === "devment") {
                  window.location =
                    "http://fexdrive.com/complete-purchase/" + url;
                }

                if (process.env.VUE_APP_NODE_TYPE === "production") {
                  window.location =
                    "http://fexspace.com/complete-purchase/" + url;
                }
              }
              // that.$refs.loading.close()
            } else {
              that.$refs.loading.close();
              that.error.message = true;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    isValidURL(string) {
      var res = string.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      );
      return res !== null;
    },
  },
  created() {
    // let externalScript = document.createElement('script')
    // externalScript.setAttribute('src', 'https://cdn.ywxi.net/js/1.js')
    // externalScript.async = true
    // externalScript.defer = true
    // document.body.appendChild(externalScript)
  },
  mounted() {
    this.year = new Date().getFullYear();
    if (this.$route.query.redirect !== undefined) {
      if (this.isValidURL(this.$route.query.redirect)) {
        cookies.setCookie(
          "redirect",
          this.$route.query.redirect,
          6 * 60 * 60 * 1000
        );
      } else {
        cookies.setCookie("redirect", this.$route.query.redirect, 0);
      }
    }

    localStorage.removeItem("current_directory_id");
    localStorage.removeItem("db");
    if (
      cookies.getCookie("token") !== "" &&
      cookies.getCookie("token") !== null
    ) {
      if (sessionStorage.getItem("status") === "true") {
        this.$router.push("/");
      }
    }

    this.SET_DIRECTORY_CHILDREN([]);
  },
};
</script>
